import axios from "axios"
import Qs from "qs"
import store from '../store'
import { Message,Loading } from 'element-ui';

// 可以取消的token
const CancelToken = axios.CancelToken;

// 数据库名称,默认华电下沙
let dbname="hdxs";

const server = axios.create({
  baseURL: process.env.VUE_APP_APIURL,
  timeout: 50 * 1000,
  withCredentials: true
})

// 加载中
let loadingInstance=null;
let loadingWhite=['/user/captcha','/user/login','user/checkloginByCode','getCurrentData']; // 加载中白名单，在白名单中的请求，不显示正在加载中

//请求拦截
server.interceptors.request.use((config) => {
  let url=config.url;
  // 是否显示加载中，默认是都显示的，除了在白名单中的，以及定义了unloading为false的，还有就是定义了unloading为数组的，
  // 定义了unloading为数组的，则会判断当前页面是否显示加载框，当前页面和定义的unloading中的内容不相符的时候，也会显示加载中
  let flag=false;
  // 根据配置内容获取是否添加loading,unloading为数组，数组内配置了哪些页面不需要加载中组件
  let unloading=config.unloading;
  if(unloading){
    let href=location.href;
    // 如果当前配置unloading中标明了当前的路由不需要显示loading，则不显示
    flag=unloading.some(function(current){
      return href.indexOf(current)>=0;
    });
  }else{
    // 如果直接定义了不显示加载框，在
    if(unloading===false){
      flag=true;
    }else{
      // 判断url是否在白名单内，如果不在白名单中，则显示加载中
      flag=loadingWhite.some(function(current){
        return url.indexOf(current)>=0;
      });
    }

  }

  // 显示正在加载中
  if(!flag){
    loadingInstance = Loading.service({ 
      fullscreen: true,
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
  }

  // 获取选中的数据库
  let db=store.getters.db;
  if(db){
    dbname=db.dburlname||dbname;
  }
  // 设置请求数据库信息
  config.headers['Database'] = dbname;

  // get请求参数在params中
  if (config.method.toLowerCase() == "get") {
    config.params = config.data?config.data:{};
  }
  // 修改默认的Content-type
  switch(config.contentType){
    case "default":
    case "json":
      config.headers['Content-Type'] = 'application/json';
      break;
    default:
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
      // 序列化参数
      config.data = Qs.stringify(config.data);
      break;
  }


  // 设置取消token
  let source=CancelToken.source();
  config.cancelToken=source.token; // 设置ajax的取消token

  let ajaxId="_"+(new Date()).getTime();
  server.id=ajaxId; // 设置ajax请求的id号

  // 在vuex中保存请求对象的取消source，这部分代码暂时没有写
  

  return config;
}, (err) => {
  return Promise.reject(err);
})

// 响应的拦截
server.interceptors.response.use((res) => {
  // 关闭加载中对话框
  if(loadingInstance){
    loadingInstance.close();
  }

  if (res.status == 200) {
    let data = res.data;
    // 权限不足
    if (data.status == 403 || data.status == 401) {
      let loginUrl=window.location.protocol+'//' + window.location.host+"/login";
      if(location.href.indexOf("/login")<0){
        Message.closeAll(); // 关闭所有实例
        Message.error("权限不足，请重新登录");
        setTimeout(function () {
            location.href = loginUrl;
        }, 2000);
      }

     
      return;
    }
    // 服务器错误
    if(data.status==500){
      let message=data.message||"服务器错误，请稍后重试";
      Message.closeAll(); // 关闭所有实例
      Message.error(message);
      return data;
    }

    // token请求
    if (data.content && data.content.token) {
      let tk=data.content.token;
      if(tk.indexOf("Bearer ")<0){
        tk="Bearer "+tk;
      }
      // 设置全局的请求
      axios.defaults.headers.common['Authorization'] = tk;
    }
    return data;
  }
  // 如果权限不足
  if (res.status == 403 || res.status == 401) {
    let loginUrl=window.location.protocol+'//' + window.location.host+"/login";
    if(location.href.indexOf("/login")<0){
      Message.closeAll(); // 关闭所有实例
      Message.error("权限不足，请重新登录");
      setTimeout(function () {
          location.href = loginUrl;
      }, 2000);
    }
  }
  return Promise.reject();
}, (err) => {
  console.log(err);

  // 关闭加载中对话框
  if(loadingInstance){
    loadingInstance.close();
  }
  // 弹出信息
  Message.closeAll(); // 关闭所有实例

  let config=err.config
  // 过滤掉不需要弹出警告的url
  if(config.url&&config.url.indexOf('user/checkloginByCode')>=0){
    return;
  }else{
    Message.error("网络错误，请稍后重试!");
  }
  return Promise.reject(err);
})

// 设置默认请求头
server.setDefault = function (options) {
  let token = options.token
  if (token) {
    if(token.indexOf("Bearer ")<0){
      token="Bearer "+token;
    }
    // 设置全局的请求
    server.defaults.headers.common['Authorization'] = token;
  }
}

export default server;